import { render, staticRenderFns } from "./AdConsent.vue?vue&type=template&id=3ac50614&scoped=true"
import script from "./AdConsent.vue?vue&type=script&lang=js"
export * from "./AdConsent.vue?vue&type=script&lang=js"
import style0 from "./AdConsent.vue?vue&type=style&index=0&id=3ac50614&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac50614",
  null
  
)

export default component.exports